import { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useSelector } from "react-redux";
import { selectors } from "../../redux-store";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chartContainer: {
      width: "100%",
      height: 300,
      marginBottom: 10,
    },
    chartPaper: {
      width: "100%",
      height: 300,
    },
  }),
);

const useDevicesInfoCharts = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const devicesInfo = useSelector(selectors.getDevicesInfo);

  //console.log(devicesInfo);

  const osDataMemo = useMemo(() => {
    const osData: { id: string; label: string; value: number }[] = [];
    if (devicesInfo) {
      Object.keys(devicesInfo?.os).forEach((key, index) => {
        osData[index] = {
          id: key,
          label: key,
          value: devicesInfo?.os[key],
        };
      });
    }
    return osData;
  }, [devicesInfo]);

  const manufacturerDataMemo = useMemo(() => {
    const manufacturerData: { id: string; label: string; value: number }[] = [];
    if (devicesInfo) {
      Object.keys(devicesInfo?.manufacturer).forEach((key, index) => {
        manufacturerData[index] = {
          id: key,
          label: key,
          value: devicesInfo?.manufacturer[key],
        };
      });
    }
    return manufacturerData;
  }, [devicesInfo]);

  const androidVersionDataMemo = useMemo(() => {
    const androidVersionData: { id: string; value: number }[] = [];
    if (devicesInfo) {
      const infoObj = devicesInfo?.androidVersion;
      Object.keys(infoObj).forEach((key) => {
        androidVersionData.push({ id: key, value: infoObj[key] });
      });
    }
    return androidVersionData;
  }, [devicesInfo]);

  const iOSVersionDataMemo = useMemo(() => {
    const iOSVersionData: { id: string; value: number }[] = [];
    if (devicesInfo) {
      const infoObj = devicesInfo?.iOSVersion;
      Object.keys(infoObj).forEach((key) => {
        iOSVersionData.push({ id: key, value: infoObj[key] });
      });
    }
    return iOSVersionData;
  }, [devicesInfo]);

  return {
    styles,
    classes,
    atomicStyles,
    osDataMemo,
    manufacturerDataMemo,
    androidVersionDataMemo,
    iOSVersionDataMemo,
  };
};

export { useDevicesInfoCharts as default };
